export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export var to_load_json_atlas = {
};


export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    'background'					: imgsPath + "reels/reels_background_{q}.png",
    'freespins_reels'				: imgsPath + "reels/freespins_reels_{q}.png",

    'dark_cover'					: imgsPath + "reels/dark_cover_{q}.png",
    /*
    'settings_background_1'			: imgsPath + 'infos/settings_background_1_{q}.png',
    'settings_background_2'			: imgsPath + 'infos/settings_background_2_{q}.png',
    'settings_background_3'			: imgsPath + 'infos/settings_background_3_{q}.png',
    */

    'settings_background'			: imgsPath + 'infos/settings_background_{q}.png',
    'info_freespins'		        : imgsPath + 'infos/info_freespins_{q}.png',
    'info_giros_gratis'				: imgsPath + 'infos/info_giros_gratis_{q}.png',
    'info_number_1'					: imgsPath + 'infos/info_number_1_{q}.png',
    'info_number_2'					: imgsPath + 'infos/info_number_2_{q}.png',
    'info_number_4'					: imgsPath + 'infos/info_number_4_{q}.png',
    'info_number_10'				: imgsPath + 'infos/info_number_10_{q}.png',
    'info_number_20'				: imgsPath + 'infos/info_number_20_{q}.png',
    'info_number_50'				: imgsPath + 'infos/info_number_50_{q}.png',
    'info_number_100'				: imgsPath + 'infos/info_number_100_{q}.png',
    'win_factor_field'				: imgsPath + 'infos/win_factor_field_{q}.png',

    'reels_cover'					: imgsPath + "reels/reels_cover_{q}.png",
    'reels_cover_top'				: imgsPath + "reels/logo_{q}.png",
    'light'							: imgsPath + "reels/light_{q}.png",

    'freespins_background'			: imgsPath + "reels/freespins_background_{q}.png",
    'freespins_counter_text'		: imgsPath + "reels/freespins_counter_text_{q}.png",

    'symbol_Joker_long'				: imgsPath + "symbols/symbol_Joker_long/symbol_Joker_long_sprite_{q}.png",
    'symbol_Joker_short'			: imgsPath + "symbols/symbol_Joker_short/symbol_Joker_short_sprite_{q}.png",

    'full_screen_background' 		: imgsPath + "reels/full_screen/background_{q}.png",
    'full_screen_light'				: imgsPath + "reels/full_screen/light_{q}.png",
    'full_screen_x2' 				: imgsPath + "reels/full_screen/x2_{q}.png",

    'freeSpins_entry_background' 	: imgsPath + "reels/freeSpins_entry_background_{q}.png",
    'freeSpins_entry_text' 			: imgsPath + "reels/freeSpins_entry_text_{q}.png",

    'bigwins_background'			: imgsPath + "bigwin/bigwins_background_{q}.png",
    'bigwins_foreground'			: imgsPath + "bigwin/bigwins_foreground_{q}.png",
    'bigwins_light'					: imgsPath + "bigwin/light_{q}.png",
    'big_win'						: imgsPath + "bigwin/big_win_{q}.png",
    'mega_win'						: imgsPath + "bigwin/mega_win_{q}.png",
    'super_mega_win'				: imgsPath + "bigwin/super_mega_win_{q}.png",
    'free_spins_win'				: imgsPath + "bigwin/free_spins_win_{q}.png",

    'flares_sprite'					: imgsPath + "bigwin/flares_sprite_{q}.png",

    'x2_lines_flares'				: imgsPath + "symbols/x2_lines_flares_{q}.png",
    'x2_lines_light_off'			: imgsPath + "symbols/x2_lines_light_off_{q}.png",
    'x2_lines_light_on'				: imgsPath + "symbols/x2_lines_light_on_{q}.png",

};

export const to_load_audio = {
    'bwin_big_win'	: audioPath + "bwin_BigWin.ogg",

    'reel_Start'		: audioPath + "reel_Start.ogg",

    'reel_stop' : audioPath + "reel_Stop.ogg",

    'bonus_FreeSpins_Counter' : audioPath + "bonus_FreeSpins_Counter.ogg",

    'win_low_1' : audioPath + "win_Low_1.ogg",
    'win_low_2' : audioPath + "win_Low_2.ogg",
    'win_low_3' : audioPath + "win_Low_3.ogg",
    'win_low_4' : audioPath + "win_Low_4.ogg",
    'win_low_5' : audioPath + "win_Low_5.ogg",
    'win_low_6' : audioPath + "win_Low_6.ogg",
    /*
    'win_mid_1' : audioPath + "win_Mid_1.ogg",
    'win_mid_2' : audioPath + "win_Mid_2.ogg",
    'win_mid_3' : audioPath + "win_Mid_3.ogg",
    'win_mid_4' : audioPath + "win_Mid_4.ogg",
    'win_mid_5' : audioPath + "win_Mid_5.ogg",
    'win_mid_6' : audioPath + "win_Mid_6.ogg",
    */
    'win_high_1' : audioPath + "win_High_1.ogg",
    'win_high_2' : audioPath + "win_High_2.ogg",
    'win_high_3' : audioPath + "win_High_3.ogg",
    'win_high_4' : audioPath + "win_High_4.ogg",
    'win_high_5' : audioPath + "win_High_5.ogg",
    'win_high_6' : audioPath + "win_High_6.ogg",

    'win_low_with_joker'	: audioPath + "win_Low_Joker.ogg",
    //'win_mid_with_joker'	: audioPath + "win_Mid_Joker.ogg",
    'win_high_with_joker'	: audioPath + "win_High_Joker.ogg",
    'win_joker_3x'			: audioPath + "win_Joker.ogg",

    'symbol_Joker_0'			: audioPath + "symbol_Joker.ogg",
    'symbol_Joker_1'			: audioPath + "symbol_Joker.ogg",
    'symbol_Joker_2'			: audioPath + "symbol_Joker.ogg",

    'win_multiplier'		: audioPath + "win_Multiplier.ogg",


    'bg_main'				: audioPath + "bg_Music.ogg",

    'bg_free_spins_loop'	: audioPath + "bg_FreeSpins_Loop.ogg",
    'bg_free_spins_start'	: audioPath + "bg_FreeSpins_Start.ogg",

    'reel_Spin'				: audioPath + "reel_Spin.ogg",

    'bonus_FreeSpins_Prepare'	: audioPath + "bonus_FreeSpins_Prepare.ogg",

    'misc_Multiplier_Bell'	: audioPath + "misc_Multiplier_Bell.ogg",

    'bwin_FreeSpins'		: audioPath + "bwin_FreeSpins.ogg",
    'bonus_FreeSpins_Start'	: audioPath + "bonus_FreeSpins_Start.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'font_bigwin' :	{
        img:	imgsPath + 'fonts/font_bigwin.png',
        xml:	imgsPath + 'fonts/font_bigwin.xml',
    },
    'font_free_spins' :	{
        img:	imgsPath + 'fonts/font_free_spins.png',
        xml:	imgsPath + 'fonts/font_free_spins.xml',
    },
    'font_freeSpins_entry' :	{
        img:	imgsPath + 'fonts/font_freeSpins_entry.png',
        xml:	imgsPath + 'fonts/font_freeSpins_entry.xml',
    },
    'font_menu' :	{
        img:	imgsPath + 'fonts/font_menu.png',
        xml:	imgsPath + 'fonts/font_menu.xml',
    },
    'font_win_lines' :	{
        img:	imgsPath + 'fonts/font_win_lines.png',
        xml:	imgsPath + 'fonts/font_win_lines.xml',
    },
    'font_wintable' :	{
        img:	imgsPath + 'fonts/font_wintable.png',
        xml:	imgsPath + 'fonts/font_wintable.xml',
    }
};

import {
    madnes_audio_allow_multiple,
    madnes_audio_levels,
    madnes_set_audio_volume
} from "../../framework/src/engine/madnes/madnes_audio";
import {to_load_audio_madnes} from "../../framework/src/engine/madnes/madnes_variables";

export function set_sounds(server_config)
{
    if(typeof server_config.volume.bigWin != "undefined")
    {
        madnes_set_audio_volume('bwin_big_win', server_config.volume.bigWin);
        madnes_set_audio_volume('bwin_FreeSpins', server_config.background.freeSpinsBackground);
    }
    if(typeof server_config.volume.buttonEffect != "undefined")
    {
        madnes_set_audio_volume('button_click', server_config.volume.buttonEffect);
    }
    if(typeof server_config.volume.spin != "undefined")
    {
        madnes_set_audio_volume('reel_Spin', server_config.volume.spin);
    }
    if(typeof server_config.volume.startReel != "undefined")
    {
        madnes_set_audio_volume('reel_Start', server_config.volume.startReel);
    }
    if(typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('reel_stop', server_config.volume.stopReel);
        madnes_audio_allow_multiple('reel_stop');
    }
    if(typeof server_config.volume.winAnim != "undefined")
    {
        madnes_set_audio_volume('win_low_1', server_config.volume.winAnim);
        madnes_set_audio_volume('win_low_2', server_config.volume.winAnim);
        madnes_set_audio_volume('win_low_3', server_config.volume.winAnim);
        madnes_set_audio_volume('win_low_4', server_config.volume.winAnim);
        madnes_set_audio_volume('win_low_5', server_config.volume.winAnim);
        madnes_set_audio_volume('win_low_6', server_config.volume.winAnim);

        madnes_set_audio_volume('win_high_1', server_config.volume.winAnim);
        madnes_set_audio_volume('win_high_2', server_config.volume.winAnim);
        madnes_set_audio_volume('win_high_3', server_config.volume.winAnim);
        madnes_set_audio_volume('win_high_4', server_config.volume.winAnim);
        madnes_set_audio_volume('win_high_5', server_config.volume.winAnim);
        madnes_set_audio_volume('win_high_6', server_config.volume.winAnim);


        madnes_set_audio_volume('win_joker_3x', server_config.volume.winAnim);
        madnes_set_audio_volume('win_multiplier', server_config.volume.winAnim);
    }
    if(typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
        madnes_set_audio_volume('bonus_FreeSpins_Counter', server_config.volume.winCounter);
    }
    if(typeof server_config.background.background != "undefined")
    {
        madnes_set_audio_volume('bg_main', server_config.background.background);
    }
    if(typeof server_config.background.freeSpinsBackground != "undefined")
    {
        madnes_set_audio_volume('bg_free_spins_loop', server_config.background.freeSpinsBackground);
        madnes_set_audio_volume('bg_free_spins_start', server_config.background.freeSpinsBackground);
    }
    if(typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }
    if(typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('symbol_Joker_0', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('symbol_Joker_1', server_config.miscSounds.miscSounds2);
        madnes_set_audio_volume('symbol_Joker_2', server_config.miscSounds.miscSounds2);
    }
    if(typeof server_config.miscSounds.miscSounds3 != "undefined")
    {
        madnes_set_audio_volume('bonus_FreeSpins_Prepare', server_config.miscSounds.miscSounds3);
        madnes_set_audio_volume('bonus_FreeSpins_Start', server_config.miscSounds.miscSounds3);
    }
    if(typeof server_config.miscSounds.miscSounds4 != "undefined")
    {
        madnes_set_audio_volume('misc_Multiplier_Bell', server_config.miscSounds.miscSounds4);
    }
    if(typeof server_config.miscSounds.miscSounds5 != "undefined")
    {
        madnes_set_audio_volume('win_low_with_joker', server_config.miscSounds.miscSounds5);
        madnes_set_audio_volume('win_high_with_joker', server_config.miscSounds.miscSounds5);
    }
    for(var i in to_load_audio_madnes)
    {
        if(typeof madnes_audio_levels[i] == "undefined")
        {
            console.log("Not set " + i);
        }
    }
}